module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('overflow-image-slide', {
    attrs: {
      "image": _vm.content.image,
      "video": _vm.content.video,
      "videoFile": _vm.content.videoFile,
      "align": _vm.content.align,
      "active": _vm.active
    }
  }, [_c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  }), _vm._v(" "), _vm._l((_vm.markedParagraphs), function(paragraph) {
    return _c('p', {
      key: paragraph.index,
      domProps: {
        "innerHTML": _vm._s(paragraph)
      }
    })
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-817afdac"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/templates/pages/overflow_page.vue
// module id = 643
// module chunks = 1